import React, { Component } from 'react';
import {
    Navbar,
    Nav,
    NavbarBrand,
    NavbarText,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem
} from 'reactstrap';
import Utils from "../../Utils";
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            profiledata: null,
            userInfo: { roles: "P" },
            proveedor: {},
            userMenuOpen: false
        };

        this.getProfileData();
        this.getProveedor();
        setTimeout(() => this.getUserInfo(), 800);
    }

    toggleNavbar() {
        this.setState(prev => ({
            collapsed: !prev.collapsed
        }));
    }

    toggleUserMenu = () => {
        this.setState(prev => ({
            userMenuOpen: !prev.userMenuOpen
        }));
    };

    async getProveedor() {
        await Utils.getProveedor()
            .then(data => {
                if (data !== undefined) {
                    this.setState({
                        proveedor: data
                    });
                }
            });
    }

    async getProfileData() {
        let profileData = await Utils.getProfileData();
        this.setState({
            profiledata: profileData
        });
    }

    async getUserInfo() {
        await Utils.getUserInfo()
            .then(data => {
                if (data.status === 200) {
                    this.setState({ userInfo: data.data });
                } else {
                    window.location.href = "/.auth/login";
                }
                if (
                    (data.data.roles === 'A' || data.data.roles === 'V') &&
                    (window.location.href !== window.location.origin + "/admin")
                ) {
                    window.location.href = window.location.origin + "/admin";
                }
            });
    }


    async logOut() {
        await Utils.logOut();
    }

    render() {
        return (
            <Navbar color="dark" container dark expand="md">
                <NavbarBrand href="/">
                    <img
                        src="/logo-score-proveedores.svg"
                        alt="logo-score"
                        width="274px"
                    />
                </NavbarBrand>
                <NavbarText id="ultimaActualizacion" style={{ color: "#fff" }} />

                <Nav className="ml-auto" navbar>
                    {this.state.profiledata && (
                        <Dropdown
                            nav
                            inNavbar
                            isOpen={this.state.userMenuOpen}
                            toggle={this.toggleUserMenu}
                        >
                            <DropdownToggle
                                nav
                                tag="span"
                                className="proveedor-toggle"
                            >
                                <div className="usuario-info">
                                    {this.state.userInfo?.roles === "A" ? (
                                        <span className="proveedor-nombre">
                                            Administrador
                                        </span>
                                    ) : (
                                        this.state.proveedor?.RazonSocial && (
                                            <span className="proveedor-nombre">
                                                Proveedor: {this.state.proveedor.RazonSocial}
                                            </span>
                                        )
                                    )}
                                    <span className="usuario-nombre">
                                        {this.state.profiledata.lastname}{" "}
                                        {this.state.profiledata.name}
                                    </span>
                                </div>
                                <img
                                    src="/icon-user.svg"
                                    alt="usuario"
                                    width="26px"
                                />
                            </DropdownToggle>

                            <DropdownMenu right>
                                {/*<DropdownItem header>*/}
                                {/*    {this.state.profiledata.lastname}{" "}*/}
                                {/*    {this.state.profiledata.name}*/}
                                {/*</DropdownItem>*/}

                                {(this.state.userInfo.roles === "A" ||
                                    this.state.userInfo.roles === "V") && (
                                        <DropdownItem>
                                            <a href="/admin">Administrar</a>
                                        </DropdownItem>
                                    )}



                                <DropdownItem onClick={() => this.logOut()}>
                                    Logout
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    )}

                    {!this.state.profiledata && (
                        <Dropdown nav inNavbar>
                            <DropdownToggle nav caret>
                                <a href="/.auth/login" style={{ color: "#fff" }}>
                                    Login
                                </a>
                            </DropdownToggle>
                        </Dropdown>
                    )}
                </Nav>
            </Navbar>
        );
    }
}